import { type JSX } from 'react'
import { ScrollReveal } from '#app/components/scroll-reveal.tsx'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '#app/components/ui/accordion.tsx'
import { Title } from './title.tsx'

let faqs = [
	{
		title: '¿Cuan confiable es la información que proporciona el asistente?',
		content: `Las respuestas del chat son altamente confiables gracias a nuestro sistema de Recuperación Aumentada por Generación (RAG),
que identifica y procesa fuentes legales relevantes para cada consulta. El asistente no inventa información;
cada respuesta está respaldada por normativas y resoluciones específicas citadas con precisión, permitiéndole
verificar las fuentes originales con un solo clic. Nuestro sistema es constantemente actualizado y validado
por especialistas en derecho para asegurar la exactitud de la información proporcionada, aunque siempre recomendamos
revisar las fuentes citadas como parte de su debido proceso de investigación legal.`,
	},
	{
		title: '¿Cómo formulas preguntas para obtener las mejores respuestas?',
		content: `Sea específico, incluyendo el área legal relevante y detalles concretos. Formule una consulta a la vez
y proporcione contexto claro. Use terminología legal cuando corresponda. Si la respuesta es insuficiente, reformule con mayor precisión.
Ejemplo: En vez de "¿Qué dice la ley sobre desalojos?", pregunte "¿Cuáles son los plazos para desalojo por falta de pago según la Ley de Arrendamientos?"`,
	},
	{
		title: '¿Qué fuentes legales utiliza el asistente?',
		content:
			'El asistente procesa TODAS normativas oficiales de Costa Rica, resoluciones de las diferentes salas de la Corte Suprema, circulares judiciales y decretos ejecutivos, priorizando las fuentes más recientes y relevantes para cada consulta.',
	},
	{
		title: '¿Se mantiene la confidencialidad de mis consultas?',
		content:
			'Absolutamente. Sus consultas y documentos subidos están protegidos por cifrado y no se utilizan para entrenar el sistema ni se comparten con terceros.',
	},
	{
		title: '¿Con qué frecuencia se actualiza la información legal?',
		content: 'Todos los días. El asistente se actualiza constantemente con nuevas fuentes legales y resoluciones.',
	},
	{
		title: '¿Puedo adjuntar documentos para análisis?',
		content:
			'Sí, contamos con un apartado especifico para análisis de documentos. Puede subir documentos legales como expedientes y escritos en formato PDF para recibir análisis detallados y recomendaciones.',
	},
	{
		title: '¿Cómo funciona el análisis de expedientes?',
		content:
			'Al cargar un expediente, el sistema extrae información clave, identifica plazos, requisitos legales y estrategias potenciales, facilitando un análisis profundo del caso.',
	},
	{
		title: '¿Qué áreas del derecho costarricense abarca?',
		content: `Cubre todas las áreas del derecho costarricense, incluyendo civil, penal, laboral, administrativo, constitucional, comercial, familia, agrario, tributario, materia de cobro,
      pensiones, violencia doméstica, tránsito, penal juvenil. Podemos abarcar todas las ramas ya que nuesto asistente inteligente decide que normativa y jurisprudencia usar en base a la consulta, justo como un abogado lo haría.`,
	},
	{
		title: '¿Puedo compartir respuestas con colegas o clientes?',
		content:
			'Sí, puede compartir respuestas específicas o conversaciones completas mediante un enlace seguro, manteniendo siempre la confidencialidad. Solo quien tenga acceso al enlace podrá ver las respuestas que usted comparte.',
	},
]

export function FAQ() {
	return (
		<section className="w-full border-b border-neutral-200 bg-white py-24 md:py-32" id="faq">
			<div className="mx-auto max-w-7xl space-y-8 px-4 py-12 sm:px-6 md:py-16 lg:px-0">
				<ScrollReveal className="max-w-3xl space-y-3">
					<Title component="h2" className="text-3xl">Preguntas frecuentes</Title>
				</ScrollReveal>
				<div className="space-y-3 text-base text-neutral-800">
					{faqs.map(faq => (
						<Faq key={faq.title} title={faq.title} content={faq.content} />
					))}
				</div>
			</div>
		</section>
	)
}

function Faq({ title, content }: { title: string; content?: string | JSX.Element }) {
	return (
		<ScrollReveal>
			<Accordion type="single" collapsible>
				<AccordionItem value="item-1" className="border-none">
					<AccordionTrigger
						className="py-1 text-neutral-800 hover:no-underline"
						iconClassName="w-4 h-4 text-neutral-400"
					>
						<p className="text-start text-body-xs text-neutral-800">{title}</p>
					</AccordionTrigger>
					<AccordionContent className="pt-2 text-sm text-neutral-600">{content}</AccordionContent>
				</AccordionItem>
			</Accordion>
		</ScrollReveal>
	)
}
